import { MiniappError } from '@/api/miniapp/client';

/** Что показать пользователю, когда чат недоступен. */
export type AiChatFault =
  /** Чат не найден: нужно открыть урок заново. */
  | 'not_found'
  /** Сдача невозможна без предпросмотра. */
  | 'needs_preview'
  /** Предыдущая задача ещё выполняется: новая не принимается. */
  | 'busy'
  /** Сессия уже завершена: можно начать новый чат. */
  | 'completed'
  /** Вложение недоступно, история устарела. */
  | 'file_missing'
  /** Задание есть в списке, но диалог по нему сервер не открывает. */
  | 'assignment_missing'
  | 'unknown';

/**
 * Ошибка бэкенда → реакция экрана.
 *
 * Разбор держится здесь, а не в компоненте: коды приходят и от ручек чата, и
 * от AI-сервиса, и экрану нужен один понятный набор состояний.
 */
export function faultOf(error: unknown): AiChatFault | null {
  if (!(error instanceof MiniappError)) return 'unknown';
  switch (error.type) {
    case 'AI_CHAT_NOT_FOUND':
      return 'not_found';
    case 'AI_CHAT_COMPLETED':
      return 'completed';
    case 'AI_CHAT_FILE_NOT_FOUND':
      return 'file_missing';
    case 'ASSIGNMENT_NOT_FOUND':
    case 'ASSIGNMENT_VARIANT_NOT_FOUND':
      return 'assignment_missing';
    case 'ANSWER_FINAL_ACCEPT':
      return 'needs_preview';
    default:
      // Потеря сессии обрабатывается общим guard-ом, здесь её показывать нечего
      if (error.isSessionLost) return null;
      // 409 от AI-сервиса означает незавершённую предыдущую задачу: чат занят,
      // и новые запросы к нему не принимаются, пока она не закончится
      return error.status === 409 ? 'busy' : 'unknown';
  }
}
